import React from "react";
import "./CommonTabsPanel.sass"

export default function TabPanel(props) {
    const {value, index, children} = props;

    return (
        <div className="TabPanel" hidden={value !== index}>
            {children}
        </div>
    )
}
